import React from "react";
import {SlotContent, Wrapper} from "./SlotCell.styles";
export const SlotCell = ({
    totalBooked,
    disabled = false,
    mode = "normal",
    hover = true,
    children
}) => {
    if (children !== undefined) {
        return <Wrapper disabled={disabled}>{children}</Wrapper>;
    }

    return (
        <Wrapper disabled={disabled} mode={mode} hover={hover}>
            <SlotContent mode={mode}>{totalBooked || 0}</SlotContent>
        </Wrapper>
    );
};
